/**
 * @ngdoc services
 * @memberof mercury.services
 * @name dialog
 */
angular.module('mercury.services.chartHelpers', [])
.factory('chartHelpers', function() {

  /**
   * Helper to generate an array of chart ticks with user provided configuration
   * for how they are determined.
   *
   * @param {*} minValue The smallest value in the data series.
   * @param {*} maxValue The largest value in the data series.
   * @param {*} roundTo The value the tick values should be rounded to, e.g. 50
   *   means each tick will be a multiple of 50.
   * @param {*} numTicks The number of ticks to produce.
   * @param {*} paddingPercentage How much headroom should be on the min/max range.
   * @returns An array of integers representing ticks to plot on an axes. When the
   *   minValue is greater than zero there will be numTicks values, when it is less
   *   than zero there will be numTicks + 1.
   */
  function generateChartTicks(minValue, maxValue, roundTo, numTicks, paddingPercentage) {
    var paddingMultiplier = (100 + paddingPercentage) / 100;

    var axesRange = (maxValue - minValue) * paddingMultiplier;

    var interval = Math.ceil(((axesRange * paddingMultiplier) / numTicks) / roundTo) * roundTo;
    var ticks = [];

    var currentTick = null;
    for (var i = -numTicks; i <= numTicks && (currentTick == null || currentTick < maxValue); i++) {
      currentTick = i * interval;
      var nextTick = (i + 1) * interval;

      if ((minValue < 0 && currentTick <= minValue && minValue <= nextTick) || currentTick >= minValue) {
        ticks.push(currentTick);
      }
    }
    return ticks;
  }

  return {
    generateChartTicks: generateChartTicks
  };
});
